import React, { useState, useRef } from 'react';
import './DownloadAndInstructions.css';

function DownloadAndInstructions() {
  const [isDownloaded, setIsDownloaded] = useState(false);
  const [showReportForm, setShowReportForm] = useState(false);
  const [issueDescription, setIssueDescription] = useState('');
  const [screenshot, setScreenshot] = useState(null);
  const [preview, setPreview] = useState(null);

  const fileInputRef = useRef(null);

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = `${process.env.PUBLIC_URL}/myscript.js`;
    link.download = 'myscript.js';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setIsDownloaded(true);
  };

  const handleReportIssue = () => {
    setShowReportForm(true);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setScreenshot(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmitIssue = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('description', issueDescription);
    formData.append('screenshot', screenshot);

    try {
      const response = await fetch('https://abc.com', {
        method: 'POST',
        body: formData
      });
      if (response.ok) {
        alert('Issue submitted successfully');
        setShowReportForm(false);
        setIssueDescription('');
        setScreenshot(null);
        setPreview(null);
      } else {
        alert('Failed to submit issue');
      }
    } catch (error) {
      alert('Error submitting issue');
    }
  };

  return (
    <div className="App">
      <button onClick={handleDownload} className="download-button">Download Script</button>
      {isDownloaded && (
        <div className="instructions">
          <h2>Instructions</h2>
          <div className="step">
            <h3>Step 1</h3>
            <p>Kindly attach the downloaded script in the head of your HTML page of the site.</p>
          </div>
          <div className="step">
            <h3>Step 2</h3>
            <p>Please pass the credentials correctly to the script.</p>
          </div>
          <button onClick={handleReportIssue} className="report-button">Report Issue</button>
        </div>
      )}
      {showReportForm && (
        <form onSubmit={handleSubmitIssue} className="report-form">
          <h2>Report an Issue</h2>
          <div>
            <label htmlFor="description">Description</label>
            <textarea
              id="description"
              value={issueDescription}
              onChange={(e) => setIssueDescription(e.target.value)}
              required
            ></textarea>
          </div>
          <div>
            <label htmlFor="screenshot">Screenshot</label>
            <input
              type="file"
              id="screenshot"
              accept="image/*"
              onChange={handleFileChange}
              ref={fileInputRef}
            />
            {preview && (
              <div className="image-preview">
                <img src={preview} alt="Screenshot Preview" />
              </div>
            )}
          </div>
          <button type="submit" className="submit-button">Submit Issue</button>
        </form>
      )}
    </div>
  );
}

export default DownloadAndInstructions;
